import { Space } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { FormatTime } from '../format-time';
import { BaseCell } from '../timesheet-table';

const SecondaryValue = styled.span`
  color: var(--gray-60);
`;

interface Props {
  minutes: number;
  percentage: number;
}
export const PercentWithTimeCell: FC<Props> = ({ minutes, percentage }) => {
  return (
    <BaseCell as={Space} size={4} align="start">
      {minutes ? (
        <>
          <span>{percentage.toFixed(1)}%</span>
          <SecondaryValue>
            (<FormatTime value={minutes} />)
          </SecondaryValue>
        </>
      ) : (
        <>-</>
      )}
    </BaseCell>
  );
};
